import { camelToSnakeCase } from "@redotech/util/string";
import { Schema, SchemaInstance } from "../type-system/schema";
import {
  baseCheckoutPackageSchema,
  examplebaseCheckoutPackageInstance,
} from "./checkout-optimization/checkout-package";
import {
  baseCheckoutTreeSchema,
  examplebaseCheckoutTreeInstance,
} from "./checkout-optimization/checkout-tree";
import {
  basePostPurchaseSchema,
  examplebasePostPurchaseInstance,
} from "./checkout-optimization/post-purchase";
import {
  exampleExtendedWarrantySchemaInstance,
  extendedWarrantySchema,
} from "./extended-warranty";
import {
  exampleYotpoLoyaltyCustomerBirthdaySchemaInstance,
  exampleYotpoLoyaltyExpirationReminderSchemaInstance,
  exampleYotpoLoyaltyOptInSchemaInstance,
  exampleYotpoLoyaltyPointsEarnedSchemaInstance,
  exampleYotpoLoyaltyPointsReminderSchemaInstance,
  exampleYotpoLoyaltyRedemptionCreatedSchemaInstance,
  exampleYotpoLoyaltyRedemptionReminderSchemaInstance,
  exampleYotpoLoyaltyReferralCompletedSchemaInstance,
  exampleYotpoLoyaltyReferralSharedSchemaInstance,
  exampleYotpoLoyaltyTierEarnedSchemaInstance,
  exampleYotpoLoyaltyTierLostSchemaInstance,
  yotpoLoyaltyCustomerBirthdaySchema,
  yotpoLoyaltyExpirationReminderSchema,
  yotpoLoyaltyOptInSchema,
  yotpoLoyaltyPointsEarnedSchema,
  yotpoLoyaltyPointsReminderSchema,
  yotpoLoyaltyRedemptionCreatedSchema,
  yotpoLoyaltyRedemptionReminderSchema,
  yotpoLoyaltyReferralCompletedSchema,
  yotpoLoyaltyReferralSharedSchema,
  yotpoLoyaltyTierEarnedSchema,
  yotpoLoyaltyTierLostSchema,
} from "./integrations/yotpo";
import {
  baseMarketingBackInStockSchema,
  baseMarketingBrowseAbandonmentSchema,
  baseMarketingCartAbandonmentSchema,
  baseMarketingCheckoutAbandonmentSchema,
  baseMarketingCsBrowseAbandonmentSchema,
  baseMarketingCsCartAbandonmentSchema,
  baseMarketingCsCheckoutAbandonmentSchema,
  baseMarketingEmailSchema,
  baseMarketingLowInventorySchema,
  baseMarketingPriceDropSchema,
  emailMarketingSignupSchema,
  exampleBaseMarketingBackInStockSchemaInstance,
  exampleBaseMarketingBrowseAbandonmentSchemaInstance,
  exampleBaseMarketingCartAbandonmentSchemaInstance,
  exampleBaseMarketingCheckoutAbandonmentSchemaInstance,
  exampleBaseMarketingCsBrowseAbandonmentSchemaInstance,
  exampleBaseMarketingCsCartAbandonmentSchemaInstance,
  exampleBaseMarketingCsCheckoutAbandonmentSchemaInstance,
  exampleBaseMarketingEmailSchemaInstance,
  exampleBaseMarketingLowInventorySchemaInstance,
  exampleBaseMarketingPriceDropSchemaInstance,
  exampleEmailMarketingSignupSchema,
  exampleMarketingDateSchemaInstance,
  exampleMarketingWarrantyRegistrationSchemaInstance,
  exampleSegmentMembershipChangeSchemaInstance,
  exampleSmsMarketingSignupSchema,
  marketingDateSchema,
  customerGroupMembershipChangeSchema as marketingSegmentMembershipChangeSchema,
  marketingWarrantyRegistrationSchema,
  smsMarketingSignupSchema,
} from "./marketing/marketing";
import {
  baseAddressVerificationFailedSchema,
  baseNewFulfillmentGroupSchema,
  baseOmsOrderReadyForPickupSchema,
  examplebaseAddressVerificationFailedInstance,
  examplebaseNewFulfillmentGroupInstance,
  examplebaseOmsOrderReadyForPickupInstance,
} from "./oms";
import {
  exampleProductSubscriptionSchemaInstance,
  ProductSubscriptionSchema,
} from "./product-subscriptions";
import {
  baseReviewsSchema,
  exampleBaseReviewsSchemaInstance,
} from "./reviews/reviews";
import {
  exampleOrderTrackingSchemaInstance,
  orderTrackingSchema,
} from "./tracking/order-tracking";
import {
  exampleFedExEasyReturnsReturnTrackingSchemaInstance,
  exampleReturnTrackingSchemaInstance,
  fedExEasyReturnsReturnTrackingSchema,
  returnTrackingSchema,
} from "./tracking/return-tracking";
import {
  exampleTnplTrackingSchemaInstance,
  tnplTrackingSchema,
} from "./tracking/tnpl-tracking";
import {
  exampleTrackingPageFlowSchemaInstance,
  trackingPageFlowSchema,
} from "./tracking/tracking-page-flow";

export enum SchemaType {
  ORDER_TRACKING = "order_tracking",
  RETURN_TRACKING = "return_tracking",
  FEDEX_EASY_RETURNS_RETURN_TRACKING = "fedex_easy_returns_return_tracking",
  TNPL_TRACKING = "tnpl_tracking",
  EMAIL_MARKETING_SIGNUP = "email_marketing_signup",
  SMS_MARKETING_SIGNUP = "sms_marketing_signup",
  MARKETING_CAMPAIGN = "marketing_campaign",
  REVIEWS = "reviews",
  MARKETING_EMAIL = "marketing_email",
  MARKETING_CART_ABANDONMENT = "marketing_cart_abandonment",
  MARKETING_BROWSE_ABANDONMENT = "marketing_browse_abandonment",
  MARKETING_CHECKOUT_ABANDONMENT = "marketing_checkout_abandonment",
  MARKETING_COMMENTSOLD_CART_ABANDONMENT = "marketing_commentsold_cart_abandonment",
  MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT = "marketing_commentsold_browse_abandonment",
  MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT = "marketing_commentsold_checkout_abandonment",
  MARKETING_BACK_IN_STOCK = "marketing_back_in_stock",
  MARKETING_SEGMENT_MEMBERSHIP_CHANGE = "marketing_segment_membership_change",
  MARKETING_WARRANTY_REGISTRATION = "marketing_warranty_registration",
  MARKETING_LOW_INVENTORY = "marketing_low_inventory",
  MARKETING_DATE = "marketing_date",
  MARKETING_PRICE_DROP = "marketing_price_drop",
  OMS_NEW_FULFILLMENT_GROUP = "oms_new_fulfillment_group",
  OMS_ORDER_READY_FOR_PICKUP = "oms_order_ready_for_pickup",
  ADDRESS_VERIFICATION_FAILED = "address_verification_failed",

  // Checkout personalization
  CHECKOUT_TREE = "checkout_tree",
  // Checkout packages
  RCO_CHECKOUT_PACKAGE = "rco_checkout_package",
  // Post-purchase flows
  POST_PURCHASE_FLOW = "post_purchase_flow",
  // Product subscriptions
  PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE = "product_subscription",
  // Extended warranty
  EXTENDED_WARRANTY = "extended_warranty",

  // Tracking page flows
  TRACKING_PAGE_FLOW = "tracking_page_flow",

  // Yotpo integration
  YOTPO_LOYALTY_EXPIRATION_REMINDER = "yotpo_loyalty_expiration_reminder",
  YOTPO_LOYALTY_POINTS_REMINDER = "yotpo_loyalty_points_reminder",
  YOTPO_LOYALTY_REDEMPTION_REMINDER = "yotpo_loyalty_redemption_reminder",
  YOTPO_LOYALTY_REDEMPTION_CREATED = "yotpo_loyalty_redemption_created",
  YOTPO_LOYALTY_REFERRAL_COMPLETED = "yotpo_loyalty_referral_completed",
  YOTPO_LOYALTY_REFERRAL_SHARED = "yotpo_loyalty_referral_shared",
  YOTPO_LOYALTY_CUSTOMER_BIRTHDAY = "yotpo_loyalty_customer_birthday",
  YOTPO_LOYALTY_OPT_IN = "yotpo_loyalty_opt_in",
  YOTPO_LOYALTY_TIER_EARNED = "yotpo_loyalty_tier_earned",
  YOTPO_LOYALTY_TIER_LOST = "yotpo_loyalty_tier_lost",
  YOTPO_LOYALTY_POINTS_EARNED = "yotpo_loyalty_points_earned",
}

export const schemas: Record<SchemaType, Schema> = {
  [SchemaType.ORDER_TRACKING]: orderTrackingSchema,
  [SchemaType.RETURN_TRACKING]: returnTrackingSchema,
  [SchemaType.TNPL_TRACKING]: tnplTrackingSchema,
  [SchemaType.EMAIL_MARKETING_SIGNUP]: emailMarketingSignupSchema,
  [SchemaType.SMS_MARKETING_SIGNUP]: smsMarketingSignupSchema,
  [SchemaType.MARKETING_CAMPAIGN]: baseMarketingEmailSchema,
  [SchemaType.MARKETING_SEGMENT_MEMBERSHIP_CHANGE]:
    marketingSegmentMembershipChangeSchema,
  [SchemaType.REVIEWS]: baseReviewsSchema,
  [SchemaType.MARKETING_EMAIL]: baseMarketingEmailSchema,
  [SchemaType.MARKETING_CART_ABANDONMENT]: baseMarketingCartAbandonmentSchema,
  [SchemaType.MARKETING_BROWSE_ABANDONMENT]:
    baseMarketingBrowseAbandonmentSchema,
  [SchemaType.MARKETING_CHECKOUT_ABANDONMENT]:
    baseMarketingCheckoutAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_CART_ABANDONMENT]:
    baseMarketingCsCartAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT]:
    baseMarketingCsBrowseAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT]:
    baseMarketingCsCheckoutAbandonmentSchema,
  [SchemaType.OMS_NEW_FULFILLMENT_GROUP]: baseNewFulfillmentGroupSchema,
  [SchemaType.OMS_ORDER_READY_FOR_PICKUP]: baseOmsOrderReadyForPickupSchema,
  [SchemaType.ADDRESS_VERIFICATION_FAILED]: baseAddressVerificationFailedSchema,
  [SchemaType.MARKETING_BACK_IN_STOCK]: baseMarketingBackInStockSchema,
  [SchemaType.MARKETING_LOW_INVENTORY]: baseMarketingLowInventorySchema,
  [SchemaType.MARKETING_WARRANTY_REGISTRATION]:
    marketingWarrantyRegistrationSchema,
  [SchemaType.MARKETING_DATE]: marketingDateSchema,
  [SchemaType.MARKETING_PRICE_DROP]: baseMarketingPriceDropSchema,
  [SchemaType.CHECKOUT_TREE]: baseCheckoutTreeSchema,
  [SchemaType.RCO_CHECKOUT_PACKAGE]: baseCheckoutPackageSchema,
  [SchemaType.POST_PURCHASE_FLOW]: basePostPurchaseSchema,
  [SchemaType.PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE]: ProductSubscriptionSchema,
  [SchemaType.EXTENDED_WARRANTY]: extendedWarrantySchema,
  [SchemaType.FEDEX_EASY_RETURNS_RETURN_TRACKING]:
    fedExEasyReturnsReturnTrackingSchema,
  [SchemaType.TRACKING_PAGE_FLOW]: trackingPageFlowSchema,
  [SchemaType.YOTPO_LOYALTY_EXPIRATION_REMINDER]:
    yotpoLoyaltyExpirationReminderSchema,
  [SchemaType.YOTPO_LOYALTY_POINTS_REMINDER]: yotpoLoyaltyPointsReminderSchema,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_REMINDER]:
    yotpoLoyaltyRedemptionReminderSchema,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_CREATED]:
    yotpoLoyaltyRedemptionCreatedSchema,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_COMPLETED]:
    yotpoLoyaltyReferralCompletedSchema,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_SHARED]: yotpoLoyaltyReferralSharedSchema,
  [SchemaType.YOTPO_LOYALTY_CUSTOMER_BIRTHDAY]:
    yotpoLoyaltyCustomerBirthdaySchema,
  [SchemaType.YOTPO_LOYALTY_OPT_IN]: yotpoLoyaltyOptInSchema,
  [SchemaType.YOTPO_LOYALTY_TIER_EARNED]: yotpoLoyaltyTierEarnedSchema,
  [SchemaType.YOTPO_LOYALTY_TIER_LOST]: yotpoLoyaltyTierLostSchema,
  [SchemaType.YOTPO_LOYALTY_POINTS_EARNED]: yotpoLoyaltyPointsEarnedSchema,
};

export const schemaInstanceExamples: Record<
  SchemaType,
  SchemaInstance<Schema>
> = {
  [SchemaType.ORDER_TRACKING]: exampleOrderTrackingSchemaInstance,
  [SchemaType.RETURN_TRACKING]: exampleReturnTrackingSchemaInstance,
  [SchemaType.TNPL_TRACKING]: exampleTnplTrackingSchemaInstance,
  [SchemaType.EMAIL_MARKETING_SIGNUP]: exampleEmailMarketingSignupSchema,
  [SchemaType.SMS_MARKETING_SIGNUP]: exampleSmsMarketingSignupSchema,
  [SchemaType.MARKETING_CAMPAIGN]: exampleBaseMarketingEmailSchemaInstance, // intentionally the same as email
  [SchemaType.MARKETING_SEGMENT_MEMBERSHIP_CHANGE]:
    exampleSegmentMembershipChangeSchemaInstance,
  [SchemaType.REVIEWS]: exampleBaseReviewsSchemaInstance,
  [SchemaType.MARKETING_EMAIL]: exampleBaseMarketingEmailSchemaInstance,
  [SchemaType.MARKETING_CART_ABANDONMENT]:
    exampleBaseMarketingCartAbandonmentSchemaInstance,
  [SchemaType.MARKETING_BROWSE_ABANDONMENT]:
    exampleBaseMarketingBrowseAbandonmentSchemaInstance,
  [SchemaType.MARKETING_CHECKOUT_ABANDONMENT]:
    exampleBaseMarketingCheckoutAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_CART_ABANDONMENT]:
    exampleBaseMarketingCsCartAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT]:
    exampleBaseMarketingCsBrowseAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT]:
    exampleBaseMarketingCsCheckoutAbandonmentSchemaInstance,
  [SchemaType.OMS_NEW_FULFILLMENT_GROUP]:
    examplebaseNewFulfillmentGroupInstance,
  [SchemaType.OMS_ORDER_READY_FOR_PICKUP]:
    examplebaseOmsOrderReadyForPickupInstance,
  [SchemaType.ADDRESS_VERIFICATION_FAILED]:
    examplebaseAddressVerificationFailedInstance,
  [SchemaType.MARKETING_BACK_IN_STOCK]:
    exampleBaseMarketingBackInStockSchemaInstance,
  [SchemaType.MARKETING_LOW_INVENTORY]:
    exampleBaseMarketingLowInventorySchemaInstance,
  [SchemaType.MARKETING_WARRANTY_REGISTRATION]:
    exampleMarketingWarrantyRegistrationSchemaInstance,
  [SchemaType.MARKETING_DATE]: exampleMarketingDateSchemaInstance,
  [SchemaType.MARKETING_PRICE_DROP]:
    exampleBaseMarketingPriceDropSchemaInstance,
  [SchemaType.CHECKOUT_TREE]: examplebaseCheckoutTreeInstance,
  [SchemaType.RCO_CHECKOUT_PACKAGE]: examplebaseCheckoutPackageInstance,
  [SchemaType.POST_PURCHASE_FLOW]: examplebasePostPurchaseInstance,
  [SchemaType.PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE]:
    exampleProductSubscriptionSchemaInstance,
  [SchemaType.EXTENDED_WARRANTY]: exampleExtendedWarrantySchemaInstance,
  [SchemaType.FEDEX_EASY_RETURNS_RETURN_TRACKING]:
    exampleFedExEasyReturnsReturnTrackingSchemaInstance,
  [SchemaType.TRACKING_PAGE_FLOW]: exampleTrackingPageFlowSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_EXPIRATION_REMINDER]:
    exampleYotpoLoyaltyExpirationReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_POINTS_REMINDER]:
    exampleYotpoLoyaltyPointsReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_REMINDER]:
    exampleYotpoLoyaltyRedemptionReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_CREATED]:
    exampleYotpoLoyaltyRedemptionCreatedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_COMPLETED]:
    exampleYotpoLoyaltyReferralCompletedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_SHARED]:
    exampleYotpoLoyaltyReferralSharedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_CUSTOMER_BIRTHDAY]:
    exampleYotpoLoyaltyCustomerBirthdaySchemaInstance,
  [SchemaType.YOTPO_LOYALTY_OPT_IN]: exampleYotpoLoyaltyOptInSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_TIER_EARNED]:
    exampleYotpoLoyaltyTierEarnedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_TIER_LOST]:
    exampleYotpoLoyaltyTierLostSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_POINTS_EARNED]:
    exampleYotpoLoyaltyPointsEarnedSchemaInstance,
};

interface DynamicVariableBase {
  key: string;
}

export type DynamicVariableText = DynamicVariableBase & {
  type: "text";
  default?: string;
};

export type DynamicVariableUrl = DynamicVariableBase & {
  type: "url";
  text: string;
};

export type DynamicVariable = DynamicVariableText | DynamicVariableUrl;

/**
 * @deprecated Use applyDynamicVariableSyntaxLiquid for new implementations.
 * This function uses the legacy syntax (| `default`) and should only be used
 * for components that haven't been migrated to Liquid templating yet (like packing slips).
 * A database migration is required to convert existing templates to Liquid syntax.
 */
export const applyDynamicVariableSyntax = (
  dynamicVariable: Omit<DynamicVariableText, "type">,
) => {
  return [
    "{{ ",
    camelToSnakeCase(dynamicVariable.key),
    `${dynamicVariable.default ? ` | \`${dynamicVariable.default}\`` : ""}`,
    " }}",
  ].join("");
};

/**
 * Creates dynamic variable syntax using Liquid templating with automatic filters
 * for array and object variables. Use this for email and SMS templates.
 */
export const applyDynamicVariableSyntaxLiquid = (
  params: Omit<DynamicVariableText, "type"> & {
    isHtml?: boolean;
    schemaType: SchemaType | null;
  },
) => {
  const { key, default: defaultValue, isHtml = true, schemaType } = params;
  const snakeCaseKey = camelToSnakeCase(key);
  const camelCaseKey = key;

  let filters = "";

  if (schemaType && schemas[schemaType]) {
    const schema = schemas[schemaType];
    const fieldDefinition = schema.fields[camelCaseKey];

    if (fieldDefinition) {
      const dataType = fieldDefinition.dataType;

      if (dataType.includes("Multiple")) {
        if (isHtml) {
          filters = '| list: "ordered"';
        } else {
          filters = '| join: ", "';
        }
      } else if (dataType === "Object") {
        filters = '| object: "pairs"';
      }
    }
  }

  if (defaultValue) {
    const defaultFilter = `| default: "${defaultValue}"`;
    filters += filters ? ` ${defaultFilter}` : defaultFilter;
  }

  return ["{{", snakeCaseKey, filters, "}}"].filter(Boolean).join(" ");
};
